import styled from '@emotion/styled';

import Card from 'components/global/Card';
import Radio from 'components/global/Radio';

import { Breakpoints } from 'utils/const.styles';

export const PageContainer = styled(Card)`
	display: flex;
	flex-direction: column;
	padding: 0;
	.section-title {
		margin-bottom: 2.5rem;
	}
`;

export const PageContent = styled.div`
	padding: 2.5rem;
`;

export const SectionContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.5rem;
	width: 100%;
`;

export const SectionTitleContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const PageHeaderContainer = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	gap: 2rem;
`;

export const PickupOptionsButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	gap: 2rem;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
	}
`;

export const PickupOptionsCard = styled(Card)`
	display: flex;
	flex-direction: row;
	width: 100%;
	padding: 3rem;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;

	:hover {
		border: 1px solid var(--blue);
	}

	&.selected {
		border: 1px solid var(--blue);
		background-color: var(--background-1);
	}
`;

export const PickupOptionsCardContent = styled.div`
	display: flex;
	flex-direction: row;
	gap: 2rem;

	.skeleton {
		min-width: 59px;
	}
`;

export const PickupOptionsTextContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;

	> .typography > span {
		color: var(--black);
	}
`;

export const PickupOptionsCardTitle = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
`;

export const StyledRadio = styled(Radio)`
	flex: 0 0 auto;
`;

export const Divider = styled.div`
	width: 100%;
	/* margin: 2.5rem 0; */
	border-bottom: 1px solid var(--border-color);
`;

export const ActionsContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	width: 100%;
	padding: 2rem;
	gap: 1rem;
	box-shadow: 0px 1px 0px 0px var(--border-color) inset;
	body[dir='rtl'] & {
		> button > .button-icon {
			transform: scaleX(-1);
		}
	}
`;

export const StyledForm = styled.div`
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	background-color: transparent;
`;

export const PaymentMethodContainer = styled.div`
	display: flex;
	width: 100%;
	@media ${Breakpoints.mobileLandscape} {
		flex-direction: column;
		gap: 2rem;
	}
`;

export const PaymentOptionsContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const PaymentCard = styled.button`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
	width: 100%;
	padding: 1rem 0;
	background: transparent;
	border: none;
	overflow: hidden;

	cursor: pointer;

	:disabled {
		cursor: not-allowed;
	}
`;

export const SummaryContainer = styled.div`
	display: flex;
	flex-direction: column;
	background: var(--modal-bg-2);
	width: 60%;
	padding: 2.5rem;
	@media ${Breakpoints.mobileLandscape} {
		width: 100%;
	}
`;

export const OrderList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	margin: 2rem 0;
	overflow: auto;
	max-height: 40rem;
`;

export const SummaryOrderCard = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 1rem;
	padding: 1rem;
	background: var(--modal-bg-1);
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);
`;

export const SummaryCardRow = styled.div`
	display: flex;
	gap: 2rem;
`;

export const SummaryCardTitle = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

export const OrderPriceSummary = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	margin: 2rem 0;
`;

export const OrderPriceRow = styled.div`
	display: flex;
	justify-content: space-between;
	&.section-mt {
		margin-top: 2rem;
	}
`;

export const SuccessCard = styled(Card)`
	height: 100%;
	padding: 0;
`;

export const SuccessContainer = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: space-between;
	padding-top: 5rem;
	height: 100%;
	@media ${Breakpoints.tablet} {
		width: 100%;
	}
`;

export const SuccessContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2.5rem;
	width: 100%;
`;

export const SuccessInfo = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1rem;
`;

export const SuccessOrderList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	padding: 2.5rem;
	background: var(--modal-bg-2);
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);
	width: 100%;
	max-width: 80rem;
	max-height: 40rem;
	@media ${Breakpoints.mobileLandscape} {
		max-height: unset;
	}
`;

export const SuccessOrderCardContainer = styled.div`
	display: flex;
	flex-direction: column;
	overflow: auto;
	gap: 1rem;
`;

export const SuccessOrderCard = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 1rem;
	padding: 1rem;
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);
	background: var(--white);
`;
